const ddadosValidar = {
  Titulo: "Validar Crachá",
  Campos: {
    InscricaoMunicipal: {
      Tipo: "number",
      Label: "Inscrição Municipal",
      Tooltip: "Inscrição Municipal",
      Placeholder: "Inscrição Municipal",
      Tamanho: 10
    },
    CpfCnpj: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF/CNPJ",
      Obrigatorio: true
    },
    Exercicio: {
      Tipo: "number",
      Label: "Exercício",
      Tooltip: "Exercício",
      Placeholder: "Exercício",
      Tamanho: 4
    },
    CodigoVerificacao: {
      Tipo: "number",
      Label: "Código de Verificação",
      Tooltip: "Código de Verificação",
      Placeholder: "Código de Verificação",
      Tamanho: 10
    },
    NumeroCracha: {
      Tipo: "text",
      Label: "Nro. do Crachá",
      Tooltip: "Nro. do Crachá",
      Placeholder: "Nro. do Crachá"
    },
    CCM: {
      Tipo: "text",
      Label: "CCM",
      Tooltip: "CCM",
      Placeholder: "CCM",
      Desabilitado: true
    },
    Nome: {
      Tipo: "text",
      Label: "Nome",
      Tooltip: "Nome",
      Placeholder: "Nome"
    },
    Praia: {
      Tipo: "text",
      Label: "Praia",
      Tooltip: "Praia",
      Placeholder: "Praia"
    },
    Produto: {
      Tipo: "text",
      Label: "Produto",
      Tooltip: "Produto",
      Placeholder: "Produto"
    },
    Vencimento: {
      Tipo: "date",
      Label: "Vencimento",
      Tooltip: "Vencimento",
      Placeholder: "Vencimento",
    }
  }
};

export { ddadosValidar };
